import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  width: auto;
  min-width: 100%;
  padding-left: ${({ theme }): string => theme.spacers!.spacer04};
  right: 0;
  top: 70px;
`;

export const LinksWrapper = styled.div`
  position: absolute;
  right: 0;
  display: none;

  &:hover {
    display: block;
  }
`;

export const LinksCard = styled.div`
  position: absolute;
  width: auto;
  min-width: 100%;
  right: 0;
  top: ${({ theme }): string => theme.spacers!.spacer03};
  background: ${({ theme }): string => theme.colors!.colorWhite};
  border-radius: ${({ theme }): string => theme.spacers!.spacer02};
  padding: ${({ theme }): string => theme.spacers!.spacer01};
  cursor: pointer;
`;

export const LinksTitle = styled.a<{ $isActive: boolean }>`
  display: block;
  font-size: 14px;
  list-style: none;
  border-radius: ${({ theme }): string => theme.spacers!.spacer02};
  padding: ${({ theme: { spacers } }): string =>
    `${spacers!.spacer03} ${spacers!.spacer09} ${spacers!.spacer03} ${spacers!.spacer02}`};
  color: ${({ theme }): string => theme.colors!.colorBlack1};

  &:hover {
    background-color: ${({ $isActive, theme }): string =>
      $isActive ? theme.colors!.colorGray6 : theme.colors!.colorGray3};
  }

  font-weight: 400;
  text-align: start;
  text-transform: none;
  text-decoration: none;
`;
